import { css } from 'styled-components'
import { maxMq, minMq } from '../../shared/styles/breakPoints'

const links = css`
  display: flex;
  gap: 24px;

  ${minMq('MD')} {
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  ${maxMq('MD')} {
    align-items: flex-end;
    flex-direction: column;
  }
`

const link = (subcategory: "event" | "report") => {
  const isEvent = subcategory === "event";
  const widthPc = isEvent ? "270px" : "200px"
  const widthSp = isEvent ? "240px" : "180px"

  return css`
    width: ${widthSp};

    ${minMq('MD')} {
      width: ${widthPc}
    }
  `
}

export const style = {
  links,
  link
}